module.exports = __webpack_public_path__ + "static/fourth_user_image2-5707bd4b116e22c9c1f6a1edab84b9ab.jpg";